PaymentInterceptor = ($rootScope, PaymentService) ->
  $rootScope.$watch (->
    PaymentService.paid()
  ), (newValue) ->
    $rootScope.paid = PaymentService.paid()
    $rootScope.$broadcast 'accountUpdated.gnp.AccountService'

PaymentInterceptor.$inject = [
  '$rootScope'
  'PaymentService'
]

module.exports = PaymentInterceptor



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/payment/payment-interceptor.coffee